import './_pagination.scss';

export default () => {};
